// extracted by mini-css-extract-plugin
export default {"connectPage":"ConnectPage_connectPage__LX8zs","videoContainer":"ConnectPage_videoContainer__Qu6ZW","button":"ConnectPage_button__7Bhs3"};